// extracted by mini-css-extract-plugin
export default {"main_layout":"Layouts_main_layout__JmXC-","content":"Layouts_content__h5ZC4"};